import { render, staticRenderFns } from "./SentenceParsingPreview.vue?vue&type=template&id=dbb98710&lang=pug&"
import script from "./SentenceParsingPreview.vue?vue&type=script&lang=js&"
export * from "./SentenceParsingPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports